import extractErrorMessage from '../utils/extractErrorMessage';
import { publicClient } from './client';

export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const response = await publicClient.post('/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greška pri otpremanju slike.');
    return {
      data: null,
      error: message,
    };
  }
};

export const uploadMultipleImages = async (files) => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images', file);
    });

    const response = await publicClient.post(
      '/upload-multiple-images',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return {
      data: response.data,
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(error, 'Greška pri otpremanju slika.');
    return {
      data: null,
      error: message,
    };
  }
};
